import { NetworkType } from '@office-start/common-types';
var networkType;
var networkTypes = [
    { keyword: 'slow-2g', networkType: NetworkType.Slow2g },
    { keyword: '2g', networkType: NetworkType.Standard2g },
    { keyword: '3g', networkType: NetworkType.Standard3g },
    { keyword: '4g', networkType: NetworkType.Standard4g },
];
export function getNetworkType() {
    if (networkType) {
        return networkType;
    }
    var connection = window.navigator['connection'];
    var effectiveType = connection && connection.effectiveType
        ? connection.effectiveType
        : 'Unknown';
    var networkInfo = {
        keyword: 'Unknown',
        networkType: NetworkType.Unknown,
    };
    networkTypes.some(function (value) {
        if (effectiveType.toLowerCase().indexOf(value.keyword) !== -1) {
            networkInfo = value;
            return true;
        }
        return false;
    });
    networkType = networkInfo.networkType;
    return networkType;
}
//# sourceMappingURL=getNetworkInfo.js.map